var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" Sie nutzen die Version "+_vm._s(_vm.applicationVersion)+" des Dashboards.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }